"use strict";
import { Percent } from "@uniswap/sdk-core";
export const slippageToleranceToPercent = (slippage) => {
  const basisPoints = Math.round(slippage * 100);
  return new Percent(basisPoints, 1e4);
};
